module.exports = __webpack_public_path__ + "static/media/tooltip_ci.4e327efd.svg";